import { useState } from "react";
import { Element, Link } from "react-scroll";
import background from "../../assets/images/Abimg.png";

export default function OurProducts() {
  const [activeNav, setActiveNav] = useState(null);

  const navItems = [
    { to: "Advantages", label: "The Athees Info Advantages" },
    { to: "Services",   label: "Our Services" },
    { to: "Careers",    label: "IT Staff Augmentation" },
    { to: "Technologies", label: "Technologies" },
  ];

  return (
    <>
      {/* ── Sub-nav ── */}
      <div
        className="d-none d-md-block position-fixed w-100"
        style={{
          top: 0,
          zIndex: 999,
          background: "rgba(255,255,255,0.96)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          boxShadow: "0 1px 12px rgba(0,0,0,0.06)",
        }}
      >
        <div className="container">
          <ul className="d-none d-md-flex justify-content-center align-items-center list-unstyled mb-0 gap-1 pb-2 pt-4 mt-5">
            {navItems.map(({ to, label }) => (
              <li key={to}>
                <Link
                  activeClass="subnav-active"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  to={to}
                  className="subnav-link"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* ── Hero ── */}
      <Element name="home">
        <div
          style={{
            height: "100vh",
            backgroundImage: `url(${background})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Overlay */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(to bottom, rgba(0,0,0,0.52) 0%, rgba(0,0,0,0.32) 60%, rgba(0,0,0,0.55) 100%)",
            }}
          />

          {/* Content */}
          <div className="container text-center position-relative" style={{ zIndex: 1 }}>
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10">
                {/* Eyebrow rule */}
                <div
                  className="d-flex align-items-center justify-content-center gap-3 mb-4"
                  data-aos="fade-up"
                  data-aos-duration="800"
                >
                  <span style={{ height: 1, width: 40, background: "rgba(255,255,255,0.45)", display: "block" }} />
                  <span
                    style={{
                      fontSize: "0.7rem",
                      fontWeight: 700,
                      letterSpacing: "0.18em",
                      textTransform: "uppercase",
                      color: "rgba(255,255,255,0.75)",
                    }}
                  >
                    Athees Info Solutions
                  </span>
                  <span style={{ height: 1, width: 40, background: "rgba(255,255,255,0.45)", display: "block" }} />
                </div>

                <h1
                  className="text-uppercase text-white"
                  data-aos="fade-up"
                  data-aos-duration="3000"
                  style={{
                    fontSize: "clamp(1.8rem, 5vw, 3.6rem)",
                    fontWeight: 800,
                    lineHeight: 1.12,
                    letterSpacing: "-0.01em",
                    marginBottom: "1.75rem",
                    textShadow: "0 2px 20px rgba(0,0,0,0.4)",
                  }}
                >
                  Fintech solutions for <br />
                  global construction markets
                </h1>

                {/* Divider */}
                <div
                  style={{
                    width: 56,
                    height: 3,
                    background: "#fff",
                    margin: "0 auto 1.75rem",
                    borderRadius: 2,
                    opacity: 0.7,
                  }}
                />

                <p
                  className="text-capitalize text-white"
                  data-aos="fade-up"
                  data-aos-duration="3000"
                  style={{
                    fontSize: "clamp(0.95rem, 1.8vw, 1.15rem)",
                    lineHeight: 1.85,
                    maxWidth: 560,
                    margin: "0 auto",
                    opacity: 0.85,
                    textShadow: "0 1px 8px rgba(0,0,0,0.3)",
                  }}
                >
                  we are a global provider of fintech solutions for central banks,{" "}
                  exchanges, central counterparties and financial market intermediaries
                </p>
              </div>
            </div>
          </div>

          {/* Scroll cue */}
          <div
            style={{
              position: "absolute",
              bottom: "2.5rem",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
              opacity: 0.6,
            }}
          >
            <span style={{ fontSize: "0.65rem", color: "#fff", letterSpacing: "0.15em", textTransform: "uppercase" }}>
              Scroll
            </span>
            <div
              style={{
                width: 1,
                height: 40,
                background: "linear-gradient(to bottom, #fff, transparent)",
              }}
            />
          </div>
        </div>
      </Element>

      {/* Scoped styles */}
      <style>{`
        .subnav-link {
          display: block;
          padding: 0.45rem 1.1rem;
          font-size: 0.78rem;
          font-weight: 600;
          letter-spacing: 0.04em;
          color: #444;
          text-decoration: none;
          border-radius: 6px;
          cursor: pointer;
          transition: background 0.18s, color 0.18s;
          white-space: nowrap;
        }
        .subnav-link:hover,
        .subnav-link.subnav-active {
          background: rgba(0,0,0,0.06);
          color: #111;
        }
      `}</style>
    </>
  );
}